import template from './sw-cms-block-youtube-video.html.twig';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
